import axios from "axios";
import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import { useTranslation } from "react-i18next";
import defaultImage from "../../../assets/img/ava.png";
import "./style.css";
import { API_BASE_URL } from "../../../config/config";

function ChiefExecutive({ departmentId }) {
  const [department, setDepartment] = useState(null);
  const { i18n, t } = useTranslation();

  useEffect(() => {
    if (!departmentId) return;

    const languageMap = {
      tj: 1,
      ru: 2,
      en: 3,
    };
    const langCode = languageMap[i18n.language] || 2;

    axios
      .get(
        `${API_BASE_URL}/api/departaments/${departmentId}?lang=${langCode}`,
        {
          headers: {
            accept: "text/plain",
            "api-version": "1.0",
          },
        }
      )
      .then((response) => {
        setDepartment(response.data);
      })
      .catch((error) => {
        console.error("Error fetching department:", error);
      });
  }, [departmentId, i18n.language]);

  if (!department) {
    return null;
  }

  return (
    <Container className="back text-white my-3 p-5 rounded positionRelShef">
      <Row className="mb-4">
        <Col sm lg="3" className="zIndex">
          <div className="image-container">
            <img
              src={department.directorPhoto || defaultImage}
              alt="Director"
              className="director-image"
            />
          </div>
        </Col>
        <Col sm lg="9" className="zIndex text-start">
          <h3 className="py-3">{department.directorName}</h3>
          {t("DirectoroftheAgency")}
          <br />
          <p>{department.description}</p>
          <b>{t("DirectorPhone")}:</b> +{department.directorPhone}
          <br />
          <b>{t("email")}:</b> {department.directorEmail}
          <br />
          <b>{t("ReceptionSchedule")}:</b> {department.directorSchedule}
        </Col>
      </Row>
    </Container>
  );
}

export default ChiefExecutive;
